@if (state(); as state) {
  <app-fullscreen-layout>
    @if (state.error) {
      <app-error-page
        [error]="state.error"
        (clickBack)="router.navigate(['/organizations', organizationId(), 'supplier-contracts'])"
        class="block"
        style="height: calc(100vh - 5rem - 10rem)"
      />
    } @else {
      <div class="flex flex-col gap-8 h-screen overflow-hidden -mt-5 -mb-10 pt-10">
        <app-parse-request-create-header [organizationId]="organizationId()" />

        <section class="flex gap-6">
          <app-parse-request-create-nav
            [parseRequest]="state.data"
            class="w-72 flex-none hidden md:block"
          />
          <div
            class="flex-1 overflow-x-hidden pb-10 overflow-y-auto scrollbar-thumb-outline dark:scrollbar-thumb-outline-darkmode scrollbar-track-surface dark:scrollbar-track-surface-darkmode"
            style="height: calc(100vh - 112px)"
          >
            <router-outlet />
          </div>
        </section>
      </div>
    }
  </app-fullscreen-layout>
}
<ui-simple-dialog #requirementsDialog class="dialog-small">
  <app-parse-request-created-requirements-dialog
    class="w-full"
    (closeDialog)="requirementsDialog.close()"
    [organizationId]="organizationId()"
  />
</ui-simple-dialog>
